
import AxiosInstance from '../config/AxiosInstance';
export interface DevicePayload {
    deviceName: string;
    serialNo: string;
    macAddress: string;
    companyId: string;
    statusId: string;
    salePointId: string;
    locationId: string;
}

const createDevices = async (payload: DevicePayload) => {
    try {
        const { data } = await AxiosInstance.post('/api/inventory/devices', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateDevices = async (id: string, payload: DevicePayload) => {
    try {
        const { data } = await AxiosInstance.put('/api/inventory/devices/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const getListDevices = async (page: number, limit: number, searchValue: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/devices/list', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
}
const getDetailDevices = async (id: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/inventory/devices/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

const deleteDevices = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/inventory/devices/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
}

export {
    createDevices,
    getListDevices,
    updateDevices,
    deleteDevices,
    getDetailDevices
}